import { I } from 'intl';
import { TcrComponent, h } from './component';
import { TcrCurrencyInput } from './currency-input';
import { TcrPercentInput } from './percent-input';
import { TcrDateInput } from './date-input';
import { TcrNumberInput } from './number-input';
import { TcrTagInput } from './tag-input';
import { TcrUserInput } from './user-input';
import { TcrComboBox } from './combobox';
import { TcrSelectList } from './select-list';
import { TcrTextInput } from './text-input';
import { TcrMapInput } from './map-input';
import { TcrMarkdownInput } from './markdown-input';

class TcrModalView extends TcrComponent
{
    constructor(props)
    {
        super(props);

        // if (typeof this.props.onDiscard !== 'function') throw 'TcrModalView missing property onDiscard.';
        if (typeof this.props.onClose !== 'function') throw 'TcrModalView missing property onClose.';
        // if (typeof this.props.onSave !== 'function') throw 'TcrModalView missing property onSave.';
        // if (typeof this.props.onDelete !== 'function') throw 'TcrModalView missing property onDelete.';

        I.Delete = { de: 'Löschen', en: 'Delete'};
		I.Edit = { de: 'Bearbeiten', en: 'Edit'};
		I.Save = { de: 'Speichern', en: 'Save'};

        this.close = this.close.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.updateModel = this.updateModel.bind(this);
        this.setStateAsync = this.setStateAsync.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.require = this.require.bind(this);
        this.setRef = this.setRef.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        this.i = 0;

        this.state = {
            item: {...props.item},
            edit: props.edit || (props.item && !props.item.id),
            changes: props.item && props.item.id ? {} : {...props.item}
        };

    }

    componentDidMount()
    {
        if (this.ref) this.ref.focus();
    }

    componentDidUpdate(prevProps, prevState)
    {
        if (!this.state.edit && this.ref)
        {
            this.ref.focus();
        }
    }

    setRef(dom)
    {
        this.ref = dom;
    }

    componentWillReceiveProps(props)
    {
        if (this.state.edit && props.item)
        {
            // if id is just a value, check equality
            if (this.state.edit && props.item && props.item.id == this.state.item.id)
            {
                return; // prevent ui update while editing
            }
            
            // if id is an array, check equality of each element
            if (Array.isArray(props.item.id) && Array.isArray(this.state.item.id) &&
                props.item.id.length === this.state.item.id.length &&
                props.item.id.every((v, i) => v === this.state.item.id[i])
            ) {
                return; // prevent ui update while editing
            }
        }

        this.setState({
            item: {...props.item},
            edit: props.edit || (props.item && !props.item.id),
            changes: props.item && props.item.id ? {} : {...props.item}
        });
    }

    updateModel(row, value, parse)
    {
        let item = JSON.parse(JSON.stringify(this.state.item));
        let changes = JSON.parse(JSON.stringify(this.state.changes));
        
        let field = row.field;

        if (Array.isArray(this.props.layout))
        {
            for (let i = 0; i < this.props.layout.length; i++)
            {
                if (this.props.layout[i].field === field && this.props.layout[i].parse)
                {
                    value = this.props.layout[i].parse(value);
                }
            }
        }

        console.log(field + ' =', value);

        if (row.reset) for (let r of row.reset)
        {
            item[r] = '';
            changes[r] = '';
        }

        if (row.onSet) for (let field in row.onSet)
        {
            item[field] = row.onSet[field](value, item);
            changes[field] = row.onSet[field](value, item);
            console.log(field + ' =', row.onSet[field](value, item));
        }

        item[field] = value;
        changes[field] = value;

        // remove from changes if new values is same as saved value
        let savedValue = this.props.item ? this.props.item[field] : undefined;
        if (savedValue === value)
        {
            delete changes[field];
        }

        this.setState({
            item: item,
            changes: changes
        });
        
    }



    onKeyDown(e)
    {
        let isMac = /(Mac)/i.test((navigator || {}).platform);
        let CmdOrCtrl = isMac ? e.metaKey : e.ctrlKey;

        if (CmdOrCtrl && e.keyCode == 83)
        {
            e.preventDefault();
            if (this.state.edit) this.save();
        }
        else if (CmdOrCtrl && e.keyCode == 69)
        {
            e.preventDefault();
            if (!this.state.edit) this.edit();
        }
        else if (e.keyCode == 27)
        {
            this.close();
        }
    }


    edit()
    {
        this.setState({edit: true});
    }

    async save()
    {
        let id = this.state.item.id || 0;
        let changes = JSON.parse(JSON.stringify(this.state.changes));

        let validatedItem = { ...this.state.item, ...changes };

        let invalidRows = (this.props.layout || [])
        .filter(row => { return !row.hideOnModal; })
        .filter(row => { return row.required; })
        .filter(row => this.require(row, validatedItem))
        .filter(row => {
            return row.validation && !(validatedItem[row.field] || '').match(row.validation);
        }).length;

        console.log('validation before save: ', invalidRows, changes);

        if (invalidRows > 0)
        {
            return window.MessageBox.show({
                title: 'Fehlende Angaben',
                text: 'Bitte füllen Sie alle Pflichtfelder aus.',
            });
        }

        if (Object.keys(changes).length > 0 && invalidRows === 0)
        {
            await this.setStateAsync({edit: false});
            if (typeof this.props.onSave === 'function')
            {
                let success = await this.props.onSave(id, changes, this.state.item);
                if (success)
                {
                    this.props.onClose();
                }
                else
                {
                    this.setState({edit: true});
                }
            }
            else
            {
                this.props.onClose();
            }
        }
        else if (id)
        {
            this.setState({edit: false});
            this.props.onClose();
        }
    }

    async delete()
    {
        await this.setStateAsync({edit: false});
        let success = await this.props.onDelete(this.state.item.id || 0);
        if (success) this.props.onClose();
        else this.setState({edit: true});
    }

    async close()
    {
        const { edit, changes } = this.state;
        const { onDiscard, onClose } = this.props;

        const hasChanges = edit && changes && Object.keys(changes).length > 0;

        // Nothing to resolve — just close.
        if (!hasChanges)
        {
            onClose();
            return;
        }

        // Temporarily exit edit mode while we ask about discarding.
        await this.setStateAsync({ edit: false });

        try
        {
            const discard = (typeof onDiscard === 'function') ? await onDiscard() : true;

            if (discard === true)
            {
                onClose();
            }
            else
            {
                // Keep editing if discard was declined.
                this.setState({ edit: true });
            }
        }
        catch (err)
        {
            // If onDiscard fails, restore edit mode.
            console.error('onDiscard failed:', err);
            this.setState({ edit: true });
        }
    }

    onScroll(e)
    {
        //console.log(e.target.scrollTop);
        this.setState({
            scrolled: e.target.scrollTop > 0
        })
    }

    require(row, item)
    {
        if (row.require)
        {
            let requires = row.require;
            if (!Array.isArray(row.require)) requires = [row.require];

            for (let require of requires)
            {
                let pass = true;
                for (let key in require)
                {
                    if (require[key].length > 0)
                    {
                        if (require[key][0] === '*')
                        {
                            if (!item[key])
                            {
                                pass = false;
                                break;
                            }
                        }
                        else if (require[key].indexOf(item[key]) < 0)
                        {
                            pass = false;
                            break;
                        }
                    }
                }
                if (pass) return true;
            }
            return false;
        }
        return true;
    }

    render()
    {
        if (!this.props.item) return;

        let rows = (this.props.layout || [])
        .filter(row => {
            return !row.hideOnModal;
        })
        .filter(row => this.require(row, this.state.item))
        .map(row =>
        {
            let input;
            let valid = !row.validation || (this.state.item[row.field] || '').match(row.validation);
            if (row.separator)
            {
                return <div class="spacer">{typeof row.separator == 'string' ? row.separator : ''}</div>;
            }
            else if (this.state.edit && !row.readonly)
            {
                if (row.type == 'select')
                {
                    console.log('options', row.options);
                    
                    let options = row.options.filter(o => {

                        if (o.require) for (let key in o.require)
                        {
                            if (o.require[key].length > 0)
                            {
                                console.log('opt req', o.require[key], this.state.item[key]);
                                
                                if (o.require[key][0] === '*')
                                {
                                    if (!this.state.item[key]) return false;
                                }
                                else if (o.require[key].indexOf(this.state.item[key]) < 0)
                                {
                                    return false;
                                }
                            }
                        }
                        return true;
                    });
                    let groups = options.map(o => { return o.group; })
                    .filter((value, index, self) => {
                        //only unique items
                        return self.indexOf(value) === index;
                    }).filter(Boolean);
                    if (groups.length)
                    {
                        groups.sort((a,b) => { return a.localeCompare(b); })
                        options = groups.map(g => {
                            return <optgroup label={g}>
                                {options.filter(o => { return o.group === g; }).map(o => {
                                    return <option value={o.value}>{o.display}</option>
                                })}
                            </optgroup>;
                        });
                    }
                    else
                    {
                        options = options.map(o => {
                            return <option value={o.value}>{o.display}</option>
                        });
                    }
                    input = [
                        <select value={this.state.item[row.field]} data-field={row.field} onInput={(e) => this.updateModel(row, e.target.value)}>
                            {options}
                        </select>,
                        <div class="arrow"></div>
                    ];
                }
                else if (row.type == 'combo')
                {
                    let options = row.options.filter(o => {
                        if (o.require) for (let key in o.require)
                        {
                            if (o.require[key].length > 0)
                            {
                                if (o.require[key][0] === '*')
                                {
                                    if (!this.state.item[key]) return false;
                                }
                                else if (o.require[key].indexOf(this.state.item[key]) < 0)
                                {
                                    return false;
                                }
                            }
                        }
                        return true;
                    });
                    input = <TcrComboBox value={this.state.item[row.field]} field={row.field} options={options} allowCustomValues={row.allowCustomValues} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'selectlist')
                {
                    let options = row.options.filter(o => {
                        if (o.require)
                        {
                            // o.require = { customer" '48' }

                            for (let key in o.require)
                            {
                                // don't diplay this option if the required key is empty
                                if (!this.state.item[key]) return false;

                                // don't diplay this option if the required key doesn't match
                                if (o.require[key] !== this.state.item[key])
                                {
                                    return false;
                                }
                            }
                        }
                        
                        return true;
                    });
                    input = <TcrSelectList value={this.state.item[row.field]} field={row.field} options={options} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'users')
                {
                    //console.log('KI', this.state.item[row.field]);
                    input = <TcrUserInput value={this.state.item[row.field]} field={row.field} options={row.options} values={row.values} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'tags')
                {
                    input = <TcrTagInput value={this.state.item[row.field]} field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'decimal')
                {
                    input = <TcrCurrencyInput value={this.state.item[row.field]} field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'number')
                {
                    input = <TcrNumberInput value={this.state.item[row.field]} field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} maxlength={row.maxlength} />;
                }
                else if (row.type == 'percent')
                {
                    input = <TcrPercentInput value={this.state.item[row.field]} field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'markdown')
                {
                    input = <TcrMarkdownInput value={this.state.item[row.field]} data-field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} />;
                    //input = <TcrTextInput value={this.state.item[row.field]} data-field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'color')
                {
                    input = <input type="color" value={this.state.item[row.field]} data-field={row.field} maxlength={row.maxlength} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'checkbox')
                {
                    input = <input type="checkbox" value="1" data-field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} checked={this.state.item[row.field] === '1'}/>;
                }
                else if (row.type == 'date')
                {
                    input = <input type="date" value={this.state.item[row.field]} data-field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
                else if (row.type == 'textarea')
                {
                    input = <textarea data-field={row.field} onInput={(e) => this.updateModel(row, e.target.value)}>{this.state.item[row.field]}</textarea>;
                }
                else if (row.type == 'date')
                {
                    input = <TcrDateInput value={this.state.item[row.field]} field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} />
                    //<input type="text" value={row.format ? row.format(this.state.item[row.field]) : this.state.item[row.field]} data-field={row.field} maxlength={row.maxlength} onInput={(e) => this.updateModel(row, e.target.value, true)} />;
                }
                else if (row.type == 'map')
                {
                    input = <TcrMapInput value={this.state.item[row.field]} field={row.field} rows={row.rows} icon={row.icon} onInput={(e) => this.updateModel(row, e.target.value)} />
                }
                else if (row.type == 'custom')
                {
                    const props = row.props || {};
                    input = <row.component value={this.state.item[row.field]} field={row.field} rows={row.rows} item={this.state.item} icon={row.icon} onInput={(e) => this.updateModel(row, e.target.value)} {...props} />
                }
                else
                {
                    // if suggestions are provided, filter for requires
                    let suggestions = [];
                    if (Array.isArray(row.suggestions))
                    {
                        suggestions = row.suggestions.filter(s =>
                        {
                            if (typeof s === 'string') return true;
                            if (!s.hasOwnProperty('require')) return true;
                            
                            for (let key in s.require)
                            {
                                // don't diplay this option if the required key is empty
                                if (!this.state.item[key]) return false;
                                
                                // don't diplay this option if the required key doesn't match
                                if (s.require[key] !== this.state.item[key])
                                {
                                    return false;
                                }
                            }
                            return true;
                        })
                        .map(s => {
                            if (typeof s === 'string') return s;
                            if (s.hasOwnProperty('value')) return s.value;
                            return '';
                        })
                        .filter(Boolean);
                    }
                    //input = <input type="text" value={this.state.item[row.field]} data-field={row.field} maxlength={row.maxlength} onInput={(e) => this.updateModel(row, e.target.value)} />;
                    input = <TcrTextInput value={this.state.item[row.field]} data-field={row.field} maxlength={row.maxlength} suggestions={suggestions} beginSuggestions={row.beginSuggestions} placeholder={row.placeholder} onInput={(e) => this.updateModel(row, e.target.value)} />;
                }
            }
            else
            {
                if (row.type == 'color')
                {
                    input = <div class="display" style={{backgroundColor:this.state.item[row.field]}}></div>;
                }
                else if (row.type == 'tags')
                {
                    input = <TcrTagInput value={this.state.item[row.field]} field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} readonly={true} />
                }
                else if (row.type == 'map')
                {
                    input = <TcrMapInput value={this.state.item[row.field]} field={row.field} rows={row.rows} icon={row.icon} onInput={(e) => this.updateModel(row, e.target.value)} readonly={true} />
                }
                else if (row.type == 'markdown')
                {
                    input = <TcrMarkdownInput value={this.state.item[row.field]} field={row.field} onInput={(e) => this.updateModel(row, e.target.value)} readonly={true} />
                }
                else if (row.type == 'custom')
                {
                    const props = row.props || {};
                    input = <row.component value={this.state.item[row.field]} field={row.field} rows={row.rows} item={this.state.item} icon={row.icon} onInput={(e) => this.updateModel(row, e.target.value)} readonly={true} {...props} />
                }
                else if (row.type == 'textarea')
                {
                    let display = this.state.item[row.field];
                    input = <div class="display multiline">{display}</div>;
                }
                else
                {
                    let display = this.state.item[row.field];
                    if (row.type == 'select')
                    {
                        for (let i = 0; i < row.options.length; i++)
                        {
                            if (row.options[i].value == display)
                            {
                                display = row.options[i].display;
                                break;
                            }
                        }
                    }
                    if (row.format)
                    {
                        display = row.format(display);
                    }
                    input = <div class="display">{display}</div>;
                }
            }
            let label = row.title ? <label>{row.title}</label> : undefined;
            return (
                <div class="row" data-key={this.state.item.id + '-' + row.field} key={this.state.item.id + '-' + row.field} data-valid={valid ? 'true' : 'false'}>
                    {input}
                    {label}
                    {row.explanation ? <div class="explanation">{row.explanation}</div> : null}
                </div>
            );
        });
        let secondaryActions;
        if (typeof this.props.onDelete === 'function')
        {
            secondaryActions = (
                <div class="secondary-actions" data-hide={!this.state.edit || !this.state.item.id}>
                    <div class="action danger" onClick={this.delete}>{this.props.deleteLabel || I.Delete}</div>
                </div>
            );
        }

        let sidebarElements = this.props.sidebar;

        let view, sidebar;
        if (this.props.customView && !this.state.edit)
        {
            view = (
                <div class="customView" onscroll={this.onScroll}>
                    <this.props.customView item={this.props.item} layout={this.props.layout} />
                </div>
            );
        }
        else
        {
            view = (
                <div class="form" onscroll={this.onScroll}>
                    {rows}
                    {secondaryActions}
                </div>
            );
        }
        if (!this.state.edit)
        {
            sidebar = (
                <div class="sidebar" data-edit={this.state.edit}>
                    {sidebarElements}
                </div>
            );
        }

        return (
            <div class="tcr-modal-view" data-hide={this.state.hide}>
                <div class="panel" data-wide={this.props.wide} data-sidebar={Array.isArray(this.props.sidebar) && this.props.sidebar.length > 0} data-edit={this.state.edit} ref={this.setRef} tabindex="-1" onKeyDown={this.onKeyDown} >
                    <div class="titlebar" data-show={this.state.scrolled}>
                        <div class="title">{this.props.title}</div>
                        <div class="actions">
                            <div class="action" data-hide={this.props.readonly || !this.props.onSave || !this.state.edit} onClick={this.save}>{this.props.saveLabel || I.Save}</div>
                            <div class="action" data-hide={this.props.readonly || !this.props.onSave || this.state.edit} onClick={this.edit}>{this.props.editLabel || I.Edit}</div>
                            <div class="x" onClick={this.close}></div>
                        </div>
                    </div>
                    <div class="main">
                        {view}
                        {sidebar}
                    </div>
                </div>
            </div>
        )
    }
}

export { TcrModalView };